"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CR_COUNT_TYPE_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.CR_COUNT_TYPE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment CRCountType on CRCountType {\n    id\n    countType\n    category {\n      id\n      category\n    }\n  }\n"], ["\n  fragment CRCountType on CRCountType {\n    id\n    countType\n    category {\n      id\n      category\n    }\n  }\n"])));
var templateObject_1;
